import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useField } from "formik";

// components
import IconButton from "./IconButton";

// assets
import DownArrow from "assets/icons/down-arrow-small.svg";
import SelectedIcon from "assets/icons/selected_icon.svg";

const SelectBranchForFilter = ({ ...props }) => {
  const { partnerList, seqPartner } = useSelector((state) => state.partner);
  const branchList =
    (partnerList.filter((item) => item.seqPartner == seqPartner)[0] || {})
      .partnerBranches || [];
  const [field, { value: seqPartnerBranch }, { setValue }] = useField(props);
  const [open, setOpen] = useState(false);

  const handleChange = (value) => {
    setValue(value);
    setOpen(false);
  };

  const branchName =
    branchList?.length > 0 && seqPartnerBranch
      ? branchList.find((el) => el.seqPartnerBranch === seqPartnerBranch)
          ?.partnerName
      : "지점 선택";

  const makeOptionList = () => {
    let options = [];
    options = branchList?.map((branch) => ({
      value: branch.seqPartnerBranch,
      label: branch.branchName || branch.partnerName,
    }));
    return options;
  };

  useEffect(() => {
    if (open) {
      const el = document.querySelector(".checkedbranch");
      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    }
  }, [open]);

  const renderOptions = () => {
    const options = makeOptionList();
    return options.map((option) => {
      const isSelected = option.value === seqPartnerBranch;
      return (
        <Option
          key={option.value}
          onClick={() => handleChange(option.value)}
          isSelected={isSelected}
          className={isSelected ? "checkedbranch" : ""}
        >
          {isSelected && <img src={SelectedIcon} />}
          {option.label}
        </Option>
      );
    });
  };

  if (open) {
    return (
      <SelectWrapper>
        <Select name={field.name}>{renderOptions()}</Select>
      </SelectWrapper>
    );
  } else {
    return (
      <Wrapper onClick={() => setOpen(true)}>
        <CurrentBranchName>{branchName}</CurrentBranchName>
        <IconButton src={DownArrow} />
      </Wrapper>
    );
  }
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  width: 100%;
  height: 48px;
  border: 1px solid #e1e6ed;
  border-radius: 8px;
  color: #515458;
`;

const SelectWrapper = styled.div`
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  left: 0;
  height: auto;
  position: absolute;
  min-height: 150px;
  background-color: white;
`;

const Select = styled.ul`
  width: inherit;
  background-color: white;
  margin-bottom: 8px;
  height: auto;
  max-height: 240px;
  border: 1px solid #e1e6ed;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: scroll;
  -ms-overflow-style: none;

  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }

  li:last-child {
    border-bottom: none;
  }
`;

const Option = styled.li`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 48px;
  padding: ${(props) => (props.isSelected ? "12px 16px" : "12px 40px")};
  border-bottom: 1px solid #e1e6ed;
  color: #515458;
  img {
    margin-right: 12px;
  }
`;

const CurrentBranchName = styled.p``;

export default SelectBranchForFilter;
